import React from 'react';

import Box from '@mui/material/Box';
import {CTAButton} from '@growcloud-io/dc/components/buttons/Buttons';

import {InnerFormField} from '@growcloud-io/dcx/form/InnerFormField';
import {InnerForm} from '@growcloud-io/dcx/form/InnerForm';

import {hasEmailAddressValidationError,validateFormValues} from '@growcloud-io/dcx/form/utils/ValidationUtils';

import LoadingProgress from '@growcloud-io/dc/components/modules/LoadingProgress';

const validateEnquiryFields = values => {
  const errors = validateFormValues(values,(key,value) => {
    let errorMessage = null;
    switch (key) {
      case 'mbox':
        if (!value) {
          errorMessage = 'Required';
        } else {
          errorMessage = hasEmailAddressValidationError(value);
        }
        break;
      default:
        break;
    }
    return errorMessage;
  })
  debugger;
  return errors
}

export const EnquiryForm = ({
  onSubmit,
  enquiryMessage,
  isActive,
  mbox = "",
  name = ""
}) => {

  let formObject = {mbox,name}

  return (
    <InnerForm
      formKey={'enquiry'}
      noValidate
      onSubmit={() => {
        onSubmit(formObject);
      }}
      validate={validateEnquiryFields}
      initialValues={{}}
      renderAction={({values}) => {
        formObject = {...values}
        return (
          <form>
            {enquiryMessage && (
              <Box sx={{margin:1}}>
                {enquiryMessage}
              </Box>
            )}
            {isActive && (
              <Box sx={{margin:1}}>
                <LoadingProgress/>
              </Box>
            )}

            <Box sx={{margin:1}}>
              <InnerFormField
                label='Mailbox'
                name='mbox'
                required
              />
            </Box>

            <Box sx={{margin:1}}>
              <InnerFormField
                label='Name'
                name='name'
                required
              />
            </Box>
            <Box sx={{margin:1}}>
              <CTAButton
                buttonText={'SUBMIT'}
                disabled={/*invalidForm || */isActive}
                onClick={() => {
                  onSubmit(formObject);
                }}
              />
            </Box>
          </form>
        )
      }}
    />
  )
}
